import { PAYMENTS_PAYMENT_TYPES } from 'Data/constants.js'
import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getText(transaction) {
  let payment = getPayment(transaction)
  if (!payment) return '-'

  switch (payment.payment_type) {
    case PAYMENTS_PAYMENT_TYPES.CreditCardPayment:
      return `Credit Card${payment.last_four_digits ? ` XXXX ${payment.last_four_digits}` : ''}`
    case PAYMENTS_PAYMENT_TYPES.BankAccountPayment:
      return `Bank Account${payment.last_four_digits ? ` XXXX ${payment.last_four_digits}` : ''}`
    case PAYMENTS_PAYMENT_TYPES.AutoPayment:
      return `${payment.type_info === 'ACH' ? 'Bank Account' : 'Credit Card'}${payment.last_four_digits ? ` XXXX ${payment.last_four_digits}` : ''}`
    case PAYMENTS_PAYMENT_TYPES.InsurancePayment:
      return 'Insurance Payment'
    case PAYMENTS_PAYMENT_TYPES.CashPayment:
      return 'Cash'
    case PAYMENTS_PAYMENT_TYPES.CheckPayment:
      return `Check${payment.check_number ? ` ${payment.check_number}` : ''}`
    case PAYMENTS_PAYMENT_TYPES.OtherPayment:
      return 'Other'
    case PAYMENTS_PAYMENT_TYPES.TransferPayment:
      return 'Transfer'
    default:
      return '-'
  }
}

function getPayment(transaction) {
  switch (transaction.type) {
    case LEDGER_ENTRY_TYPE.APPLIED_PAYMENT:
      return transaction.applied_payment?.payment
    case LEDGER_ENTRY_TYPE.PAYMENT:
      return transaction
    default:
      return null
  }
}
